import React, { useEffect, useState } from 'react';

interface DelayedLoaderProps {
    isLoading: boolean;
    delay?: number;
    children: React.ReactNode;
}

const DelayedLoader = ({ isLoading, delay = 200, children }: DelayedLoaderProps) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (!isLoading) {
            setIsVisible(false);

            return;
        }

        const timer = setTimeout(() => setIsVisible(true), delay);

        return () => clearTimeout(timer);
    }, [isLoading, delay]);

    if (!isVisible) {
        return null;
    }

    return children;
};

export default DelayedLoader;
